import { combineReducers } from 'redux';

import adresses from './adresses/reducer';
import data from './data/reducer';
import item from './item/reducer';
import order from './order/reducer';

export default combineReducers({
  adresses,
  data,
  item,
  order,
});
